import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Carousel from "react-material-ui-carousel"
import LoginBanner from './LoginBanner';
import { bizpost } from '../../ajax';
import { Box } from '@mui/material';

const s:any = {
  master: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'vertical',
    paddingBottom: 50,
  },
  bannerbox:{
    // height: '100%',
    //width: 400,
    backgroundImage: 'url(lib/img/bg02.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
  },

  carousel:{
    // height: '100%',
    width: 400,
    //backgroundImage: 'url(lib/img/bg02.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
  },
}

class LoginCarousel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: this.props.value,
      mode: 'banner',
      items: [],
      autoPlay:true,
      animation: 'slide',
      indicators: true,
      timeout: 10000
    };
  }

  componentDidMount(){
    this.refresh();
  }

  refresh = async() => {
    try{
      const params = {s:'uicontent',a:'doc',dcc:'BANNER',dvc:'ALL',lgc:'ALL'};
      this.setState({loading:true});
      const response = await bizpost(params);
      console.log('uicontent response ',response);
      if (response.success){
        const {sd:items} = response;
        this.setState({mode:'slider',items});
      }
      else if(response.failure){
        this.setState({mode:'banner'});
      }      
    }
    catch(err){
      this.setState({mode:'banner'});
    }
    finally{
      this.setState({loading:false});
    }
  }

  // handleChange = () => {
  //   // let value = event.target.value;
  //   // this.props.onChange(value);
  //   // this.setState({value});
  // };

  render() {
    const {classes } = this.props;
    const {mode,items} = this.state;
    const {autoPlay,animation,indicators,timeout,navButtonsAlwaysVisible,navButtonsAlwaysInvisible} = this.state;

    return (
      <Box sx={{...s.master}}>
        {(mode==='slider')?
        <Carousel
            sx={{...s.carousel}}
            autoPlay={autoPlay}
            animation={animation}
            indicators={indicators}
            interval={timeout}
            navButtonsAlwaysVisible={navButtonsAlwaysVisible}
            navButtonsAlwaysInvisible={navButtonsAlwaysInvisible}>
          {
            items.map((item:any, index:number) => {
                return <LoginBanner item={item} key={index} />
            })
          }
        </Carousel>
        :
        <Box sx={{...s.bannerbox}}>
            {/* <!-- Left Panel --> */}

        </Box>
      }
      </Box>
    );
  }
}

LoginCarousel.propTypes = {
  classes: PropTypes.object.isRequired,
  //id: PropTypes.string.isRequired,
  //label: PropTypes.string.isRequired,
};

export default LoginCarousel;
